import React from "react";
import {categoryService} from "../jwt/_services/clasificator/categoryService";

export const categoryProvider = {
    getOptions,
    getItem,
};

async function getOptions(customFilter) {
    try {
        const listItems = await categoryService.getOptions( customFilter );
        listItems.data.sort((a, b) => a.name?.localeCompare(b.name));
        return listItems.data.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code + '-' + item.name,
                    label: <label>{ item.code?.toUpperCase() + ' - '  } <b>{ item.name }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}

async function getItem(id) {
    try {
        const item = await categoryService.getItem(id);

        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message);
    }
}